import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const CustomSelectContainer = styled.div<{ isEditing: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
  padding: 12px;
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;
  box-shadow: ${({ isEditing }) =>
    isEditing
      ? `0 16px 24px 0 rgba(0, 0, 0, 0.06),
         0 2px 6px 0 rgba(0, 0, 0, 0.04),
         0 0 1px 0 rgba(0, 0, 0, 0.04)`
      : 'none'};

  @media (max-width: 600px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Label = styled.label`
  color: ${customPalette.accent.main};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 1.5px;
  margin-bottom: 8px;
  padding: 12px;

  @media (min-width: 600px) {
    margin-bottom: 0;
    margin-right: 16px;
    padding: 12px;
  }
`;

export const StyledIconButton = styled(IconButton)`
  color: ${customPalette.blue.main};
  background-color: ${customPalette.accent.white};
  border-radius: 50%;
  box-shadow: none;
  margin-left: auto;
`;
